export const documentAnalysisModes = [
  'contract_review',
  'argument_strengthener',
  'document_compliance',
  'weakness_finder',
] as const

export type DocumentAnalysisMode = typeof documentAnalysisModes[number]

export const isDocumentAnalysis = (agentMode: unknown): agentMode is DocumentAnalysisMode => (documentAnalysisModes as readonly unknown[]).includes(agentMode)
